"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledLink = exports.StyledArrowRightThin = exports.StyledArrowLeftThin = exports.ItemWrapper = exports.BreadcrumbsWrapperMobile = exports.BreadcrumbsWrapperDesktop = exports.BreadcrumbsWrapper = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const BreadcrumbsWrapper = exports.BreadcrumbsWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  color: 'inherit',
  display: 'flex',
  flexDirection: 'row',
  fontFamily: 'inherit',
  fontSize: '1.2rem'
}));
const BreadcrumbsWrapperMobile = exports.BreadcrumbsWrapperMobile = (0, _mui.styled)(BreadcrumbsWrapper, {
  name: 'BreadcrumbsWrapper',
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['disableMobileLayout'])
})(({
  disableMobileLayout,
  theme
}) => ({
  display: disableMobileLayout ? 'none' : 'flex',
  [theme.breakpoints.up('sm')]: {
    display: 'none'
  }
}));
const BreadcrumbsWrapperDesktop = exports.BreadcrumbsWrapperDesktop = (0, _mui.styled)(BreadcrumbsWrapper, {
  name: 'BreadcrumbsWrapper',
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['disableMobileLayout'])
})(({
  disableMobileLayout,
  theme
}) => ({
  display: disableMobileLayout ? 'flex' : 'none',
  [theme.breakpoints.up('sm')]: {
    display: 'flex'
  }
}));
const StyledLink = exports.StyledLink = (0, _mui.styled)(_mui.Link, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isLast'])
})(({
  isLast,
  theme
}) => ({
  color: 'inherit',
  fontWeight: isLast ? 'bold' : 'normal',
  marginLeft: theme.spacing(1),
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '90vw',
  '&:hover, &:focus': {
    color: 'inherit',
    fontWeight: isLast ? 'bold' : 'normal',
    textDecoration: 'underline'
  },
  [theme.breakpoints.up('sm')]: {
    marginLeft: 0
  }
}));
const StyledArrowLeftThin = exports.StyledArrowLeftThin = (0, _mui.styled)(_icons.ArrowLeftThin)(({
  theme
}) => ({
  fontSize: '1.8rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1rem'
  }
}));
const StyledArrowRightThin = exports.StyledArrowRightThin = (0, _mui.styled)(_icons.ArrowRightThin)(({
  theme
}) => ({
  fontSize: '1.8rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1rem'
  }
}));
const StyledWrapper = exports.StyledWrapper = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex'
});
const ItemWrapper = exports.ItemWrapper = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  numberOfItems = 0
}) => ({
  fontSize: '1.2rem',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1.5),
  position: 'relative',
  [theme.breakpoints.up('sm')]: {
    maxWidth: numberOfItems ? `calc(90vw / ${numberOfItems} - ${theme.spacing(1)})` : 'none',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));
//# sourceMappingURL=styles.js.map